import React, { Component, Fragment } from 'react';
import { Label } from '../../components/FormInputs'
import { css, StyleSheet } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import { AppButton } from './AppButton';
import { AppConfig } from '../../AppConfig';
import { CustomMultiSelectSearchBarStyles } from '../../styles/CustomStyles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Chip, TextField } from '@material-ui/core';

export class MultiselectFilterBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedItems: props.value || []
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        selectedItems: this.props.value || []
      })
    }
  }

  render() {
    const formDefinition = {
      label: this.props.label || '',
      placeholder: this.props.placeholder || 'Select Items',
    }

    const handleSelectBox = (e, value) => {
      this.setState({
        selectedItems: value
      })
      if (value.length === 0) this.props.onSearch([])
    }
    const handleSearch = () => {
      this.props.onSearch(this.state.selectedItems)
    }

    const multiSelectInput = () => {
      return (
        <div className={css(Styles.textBoxContainer, Styles.containerStyle)}>
          {formDefinition.label && <Label label={formDefinition.label} item={formDefinition} />}
          <Autocomplete
            multiple
            value={this.state.selectedItems}
            options={this.props.items}
            getOptionLabel={(option) => option.title || option.text}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip variant='outlined' label={option.title} {...getTagProps({ index })} />
              ))
            }
            onChange={(e, val) => handleSelectBox(e, val)} // This is the field key, not dropdown list key
            renderInput={(params) => (
              <TextField {...params}
                placeholder={this.state.selectedItems && this.state.selectedItems.length === 0 ? formDefinition.placeholder : ''}
                className={css(Styles.textFeildStyle, Styles.selectStyle)}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  classes: {
                    root: css(Styles.textInputStyles, Styles.selectInputStyle)
                  }
                }} />
            )}
          />
        </div>
      )
    }

    return (
      <div className={css(Styles.container)}>
        <form key='form' autoComplete='off' className={css(Styles.form)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(); } }}>
          <div className={css(Styles.innerContainer)}>
            {this.props.items.length > 0 && (
              <Fragment>
                <div className={css(Styles.searchContainer)}>
                  {multiSelectInput()}
                </div>
                <div className={css(Styles.buttonInnerContainer)}>
                  <AppButton
                    inProcess={this.props.inProcessSearch || false}
                    buttonStyle={Styles.button}
                    buttonTextStyle={Styles.buttonText}
                    progressIcon={Styles.progressIcon}
                    onClick={handleSearch.bind(this)}
                    buttonText={'Filter'}
                  />
                </div>
              </Fragment>
            )}
            {this.props.onList &&
              <div className={css(Styles.buttonInnerContainer,Styles.showRecentButtonContainer)}>
                <AppButton
                  inProcess={this.props.inProcessOnList || false}
                  buttonStyle={Styles.showRecentbutton}
                  buttonTextStyle={Styles.buttonText}
                  progressIcon={Styles.progressIcon}
                  onClick={this.props.onList.bind(this)}
                  buttonText={this.props.resetFilterText || 'Show recent'} />
              </div>
            }
          </div>
        </form>
      </div>
    )
  }
}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('MultiSelectFilterBar')) ? CustomMultiSelectSearchBarStyles : StyleSheet.create({
  container: {
    // minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  selectStyle: {
    minWidth: 150,
    padding: '0px !important',
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: AppTheme.borderRadius,
    backgroundColor: 'white',
    minHeight: '46px !important'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  innerContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  searchContainer: {
    flex: 1
  },
  buttonInnerContainer: {
    paddingLeft: 10,
    minWidth: 130,
    '@media (max-width: 767px)': {
      flex: 1,
      paddingLeft: 0
    }
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  progressIcon: {
    color: AppTheme.primaryColor
  },
  button: {
    color: AppTheme.primaryColor,
    border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg
  },
  textBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    // marginBottom: 32,
  },
  textFeildStyle: {
    minHeight: 54,
    borderRadius: 16,
    backgroundColor: '#F6F6F8',
  },
  textInputStyles: {
    border: 'none',
    padding: '0px 14px',
    flex: 1,
    textAlign: 'left',
    fontSize: 16,
    color: '#000000',
    '::placeHolder': {
      color: '#747474',
    }
  },
  selectInputStyles: {
    fontSize: 16,
    color: '#000000',
    margin: 0
  },
  showRecentbutton:{
    color: AppTheme.primaryColor,
    border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg,
    display: 'inline-flex'
  },
  showRecentButtonContainer: {
    textAlign: 'right'
  }
})


// WEBPACK FOOTER //
// ./src/common/components/MultiselectFilterBar.js